import Usuario from './Usuario'



class Tiponotificacao {
    constructor(
        {
            id = null,

            tipo_nit_nap = null,
            descricao = null,
            layout = null,
            codigo = null,
            created_at = null,
            updated_at = null,
            deleted_at = null,
            usuario_id = null,

            //ORM
            usuario = {}
        } = {}
    ) {
        this.id = id;
        this.tipo_nit_nap = tipo_nit_nap;

        this.descricao = descricao;
        this.layout = layout;
        this.codigo = codigo;

        this.created_at = created_at;
        this.updated_at = updated_at;
        this.deleted_at = deleted_at;        
        this.usuario_id = usuario_id;

        //ORM
        this.usuario = usuario ? new Usuario(usuario) : new Usuario();
    }

    isNIT(){
        return  this.tipo_nit_nap === 'NIT';
    }

    isNIC(){
        return this.tipo_nit_nap === 'NIC';
    }

    isNAE(){
        return this.tipo_nit_nap === 'NAE';
    }

    isNAP(){
        return this.tipo_nit_nap === 'NAP';
    }    

}

export default Tiponotificacao;